import styled from "styled-components";
import { getThemeColor } from "../../Helpers/themes";

const ThemeBackgroundColor = styled.div`
  background-color: ${({ theme, variant, shade }) =>
    getThemeColor(theme, variant, shade)};
`;

export default ThemeBackgroundColor;
